import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import '../../scss/Footer.scss'
import { currentSite } from '../../mixins/siteDetection'

class Footer extends Component {
  render() {
    const site = currentSite()

    return (
      <footer className="page-footer">
        <div className="container">
          <div className="notice">
            All characters on this site are 18+. It&#39;s drawn material, even
            if they don&#39;t look like it, they are all 18+.
            <Link to="/contact?type=report">
              Please report any concerns you might have here.
            </Link>
          </div>

          <div className="row">
            <div className="col-6 col-md-3 mb-3 mb-md-0">
              <h4>Useful Links</h4>

              <Link to="/parodies">Parodies</Link>
              <Link to="/tags">Tags</Link>
              <Link to="/2257">2257 Notice</Link>
            </div>
            <div className="col-6 col-md-3 mb-3 mb-md-0">
              <h4>Advertise</h4>
            </div>
            <div className="col-6 col-md-3">
              <h4>Partners</h4>

              <a
                href="https://www.simply-hentai.com/web"
                rel="noopener noreferrer"
                target="_blank"
              >
                Simply Hentai
              </a>
              {site.siteKey === 'doujin' ? (
                <a
                  href="https://hentaizilla.com"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  HentaiZilla
                </a>
              ) : (
                ''
              )}
              <Link to="/contact?type=partner">Become a Partner</Link>
            </div>
            <div className="col-6 col-md-3">
              <h4>Contact</h4>

              <Link to="/contact">Contact</Link>
              <Link to="/contact?type=advertisement">Advertise</Link>
              <Link to="/contact?type=dmca">DMCA</Link>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
